import React, { FC } from "react";
import { BankTransactionsLayout } from "@banks/layouts";

export const BankTransactionsPage: FC = () => {
    return <BankTransactionsLayout />;
};
